export default __webpack_public_path__ + "static/lifestyle_1_desktop-99a242838e804bb2da3a529d634a5782.png";